<template>
  <b-modal
    id="project-snapshots-modal"
    centered
    scrollable
    size="xl"
    :title="$t('show_snapshots')"
    ok-only
    :ok-title="$t('close')"
    :hide-footer="true"
  >
    <div class="mt-5">
      <lazy-list-display-y
        :nb="Object.keys(snapshots).length"
        class="mt-5 mb-3 synaplus-cosmo-h-480"
      >
        <template #default="{nby, height, initialized}">
          <b-row
            v-if="initialized"
            :key="nby"
            :style="height"
            class="cursor_pointer"
            :class="snapshot_element_dynamic_classes(nby)"
            @click="selected_item_index = nby"
            @dblclick="load_project_snapshot(snapshots[nby].uid)"
          >
            <b-col class="flex-h-stretch text-truncate">
              {{ snapshots[nby].snapshot_name }}
            </b-col>
            <b-col class="text-truncate">
              {{ $t('saved') }}
              {{ pretty_creation_dt(snapshots[nby].time_saved) }}
            </b-col>
            <b-col class="text-truncate">
              {{ snapshots[nby].nb_bricks }} {{ $t('bricks') }}
            </b-col>
            <b-col class="text-truncate">
              {{ snapshots[nby].snapshot_hash }}
            </b-col>
          </b-row>
          <div v-else :key="nby">&nbsp;Loading...</div>
        </template>
      </lazy-list-display-y>
      <b-row>
        <b-button
          variant="primary"
          class="mx-3"
          @click="save_project_snapshot()"
        >
          {{ $t('new_snapshot') }}
        </b-button>
        <b-button
          variant="danger"
          class="mr-3"
          :disabled="selected_item_index === -1"
          @click="delete_project_snapshot(snapshots[selected_item_index].uid)"
        >
          {{ $t('delete_selected') }}
        </b-button>
        <b-button
          variant="success"
          :disabled="selected_item_index === -1"
          @click="load_project_snapshot(snapshots[selected_item_index].uid)"
        >
          {{ $t('load_selected') }}
        </b-button>
      </b-row>
    </div>
  </b-modal>
</template>

<i18n>
{
  "en": {
    "load_selected": "Load selected snapshot",
    "new_snapshot": "Create new snapshot",
    "delete_selected": "Delete selected snapshot"
  },
  "fr": {
    "load_selected": "Charge la sauvegarde sélectionnée",
    "new_snapshot": "Nouvelle sauvegarde",
    "delete_selected": "Supprimer la sauvegarde séelctionnée"
  }
}
</i18n>

<style lang="scss" scoped>
@import '@/custom-bootstrap.scss';
.cursor_pointer {
  cursor: pointer;
  user-select: none;
}
.unselected_item:hover {
  background-color: $lightblue;
}
.selected_item {
  color: $white;
  background-color: $blue;
}
</style>

<script>
import _ from 'lodash'
import { mapGetters } from 'vuex'
import { subscription_mixin } from '@/components/mixin.js'
import {
  save_project_snapshot,
  load_project_snapshot,
  delete_project_snapshot,
} from '@/api/subscriptions.js'
import LazyListDisplayY from '@/components/lazy_list_display_y.vue'

export default {
  name: 'ProjectSnapshots',
  components: {
    LazyListDisplayY,
  },
  mixins: [subscription_mixin],
  props: ['project_id'],
  data() {
    return {
      selected_item_index: -1,
    }
  },
  computed: {
    snapshots() {
      let project_snapshots = this.automl_project_snapshots_undeleted_object_per_project(
        this.project_id
      )
      let res = _.map(
        project_snapshots.lists || [],
        v => project_snapshots.project_snapshots[v]
      )
      return res
    },
    ...mapGetters(['automl_project_snapshots_undeleted_object_per_project']),
  },
  beforeMount() {
    this.fetch_collections(['projects_snapshots'])
  },
  methods: {
    snapshot_element_dynamic_classes(index) {
      let res =
        this.selected_item_index == index
          ? ['selected_item']
          : ['unselected_item']
      return res
    },

    pretty_creation_dt(creation_dt) {
      let res = creation_dt
      if (!_.isUndefined(res)) {
        res.locale(this.$store.state.locale)
        res = res.calendar()
      }
      return res
    },
    async save_project_snapshot() {
      await save_project_snapshot(this.project_id)
    },
    async load_project_snapshot(snapshot_uid) {
      await load_project_snapshot(this.project_id, snapshot_uid)
      this.$bvModal.hide('project-snapshots-modal')
    },
    async delete_project_snapshot(snapshot_uid) {
      await delete_project_snapshot(this.project_id, snapshot_uid)
    },
  },
}
</script>
